module.exports = __webpack_public_path__ + "static/media/search.020ec0f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.svg
// module id = 81
// module chunks = 0